import React from 'react'
// import './style.css'
import Type1 from './types/1'
import Type2 from './types/2'
import Type3 from './types/3'
import Type4 from './types/4'

function Loader({active, type}){

    const Component = {
        1: Type1,
        2: Type2,
        3: Type3,
        4: Type4,
    }[type]

    return (
        <Component 
            active={active}
            />
    )
}

export default Loader